// Wordmark-only client wall. Uniform, premium, scrolls horizontally.
const clients = [
  "Boeing",
  "MasterCard",
  "Hilton",
  "Gulfstream",
  "Hallmark",
  "UCLA",
  "Seattle Study Club",
  "CareCredit",
  "AACD",
  "AADGP",
  "Chicago Dental Society",
  "Atlantic Implant Institute",
  "EERA",
  "Federated Investors",
  "Bay View Bank",
  "Central Financial Group",
  "Cain Watters",
  "Excelladerm",
];

export default function ClientMarquee() {
  const doubled = [...clients, ...clients];

  return (
    <section
      data-testid="client-marquee"
      className="bg-[#050505] py-16 md:py-20 border-t-4 border-[#EC1985] overflow-hidden relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-12 text-center">
        <div className="inline-flex items-center gap-3 mb-4">
          <div className="h-px w-10 bg-[#EC1985]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#EC1985] font-bold">
            Trusted by Industry Leaders
          </span>
          <div className="h-px w-10 bg-[#EC1985]" />
        </div>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black text-white tracking-tight">
          Fortune 500 stages.{" "}
          <span className="text-[#EC1985]">Dental icons.</span>{" "}
          <span className="text-white/50">Education leaders.</span>
        </h2>
      </div>

      {/* Edge fades to blend the scroll into the section */}
      <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-[#050505] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-[#050505] to-transparent z-10 pointer-events-none" />

      <div className="marquee-track">
        {doubled.map((name, i) => (
          <div
            key={i}
            data-testid={`client-name-${i}`}
            className="flex items-center gap-10 md:gap-14 px-6 md:px-8 shrink-0"
          >
            <span className="font-display text-2xl md:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white whitespace-nowrap">
              {name}
            </span>
            <span className="text-[#EC1985] text-2xl md:text-3xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
